import { Box, makeStyles, Theme } from '@material-ui/core';
import { StandardDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { PaReconciliation } from './paReconciliation';

const useStyles = makeStyles((theme: Theme) => ({
  // Replaces StandardDialog's default content box (m={4} flexGrow={1}) adding minWidth: 0,
  // so the flex item does not grow with the wide tables and the horizontal scroll stays inside the card.
  contentBox: {
    flexGrow: 1,
    minWidth: 0,
    width: '100%',
    margin: theme.spacing(4),
  },
}));

interface IPaReconciliationDialogProps {
  loanId?: number;
  open: boolean;
  onClose: () => void;
}

export const PaReconciliationDialog = observer(({ loanId, open, onClose }: IPaReconciliationDialogProps) => {
  const classes = useStyles();

  return (
    <StandardDialog
      open={open}
      title="PA Reconciliation & Refund"
      maxWidth="xl"
      handleClose={onClose}
      removeContentBox
      dialogContent={
        <Box className={classes.contentBox}>
          {open && <PaReconciliation loanId={loanId} />}
        </Box>
      }
    />
  );
});
